import React, { ReactNode } from "react";
import "./LearningPage.css";

type LearningPageParentProps = {
  readonly children: ReactNode;
};

export default function LearningPageParent({
  children,
}: LearningPageParentProps) {
  return <aside className="learning-parent">{children}</aside>;
}
